import { render, staticRenderFns } from "./Product_cb_privacy.vue?vue&type=template&id=38574fef&scoped=true&"
import script from "./Product_cb_privacy.vue?vue&type=script&lang=js&"
export * from "./Product_cb_privacy.vue?vue&type=script&lang=js&"
import style0 from "./Product_cb_privacy.vue?vue&type=style&index=0&id=38574fef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38574fef",
  null
  
)

export default component.exports